/**
 * Phantasy Live2D SDK
 * Main entry point for the SDK
 */

// Core SDK
export { PhantasyLive2D } from './core/PhantasyLive2D';

// React integration
export { usePhantasyLive2D } from './react/usePhantasyLive2D';

// Types
export type {
  PhantasyLive2DConfig,
  Live2DModelConfig,
  TTSConfig,
  TTSProviderConfig,
  LipSyncConfig,
  FeatureConfig,
  SDKDefaults,
} from './types/config';

export type { EventMap, EventCallback, EventEmitter } from './types/events';

export type {
  Live2DModel,
  Live2DCoreModel,
  Live2DInternalModel,
  PIXIApplication,
  PIXIContainer,
  PIXI,
} from './types/live2d';

// Utilities
export { createLogger } from './utils/logger';

// Version
export const VERSION = '0.2.6';
